import { render, staticRenderFns } from "./TableCustomMessage.vue?vue&type=template&id=202ff771&"
import script from "./TableCustomMessage.vue?vue&type=script&lang=js&"
export * from "./TableCustomMessage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports